var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearningArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1372",
    "data-name": "Group 1372",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10.787,
    height: 12.359,
    viewBox: "0 0 10.787 12.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    "data-name": "Rectangle 433",
    width: 10.787,
    height: 12.359,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1371",
    "data-name": "Group 1371",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M1.432.008,9.606,0a1.316,1.316,0,0,1,1.18,1.2V9.715a.562.562,0,0,1-.61.5H1.5A.548.548,0,0,0,1.532,11.3l8.777,0a.529.529,0,0,1,.093,1.035c-2.962.044-5.932,0-8.9.02A1.62,1.62,0,0,1,0,10.907V1.422A1.63,1.63,0,0,1,1.432.008M2.06,1.056H1.478a.894.894,0,0,0-.231.121.9.9,0,0,0-.189.272V9.24c.089.008.236-.081.312-.081H2.06ZM5.414,3.42a.754.754,0,0,0-.631.535A11.6,11.6,0,0,0,4.742,6.03a.746.746,0,0,0,1.147.63c.524-.279,1.039-.716,1.562-1.012A.737.737,0,0,0,7.4,4.514a13,13,0,0,0-1.551-1,.838.838,0,0,0-.431-.1",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningArea);
export default __webpack_public_path__ + "static/media/learningArea.db3fb905c7c899e9f4031f9dd69de3b8.svg";
export { ForwardRef as ReactComponent };